import { isNil } from "@etudescarre/utils";
import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api/client";
import { useYardContext } from "@/providers/yard-context";

export type ReportDraft = {
  id: number;
  numero: string | null;
  hasPdf: boolean;
};

/** Draft reports the caller can reopen, for one emitting contract. */
export function useReportDrafts(contractId: number | null): ReportDraft[] {
  const { yard } = useYardContext();
  const [drafts, setDrafts] = useState<ReportDraft[]>([]);

  useEffect(() => {
    setDrafts([]);
    if (isNil(contractId)) return;
    let cancelled = false;
    async function fetchDrafts() {
      const { data } = await apiClient.GET(
        "/api/yards/{yardId}/reports/drafts",
        {
          params: {
            path: { yardId: String(yard.id) },
            query: { emetteurContractId: contractId ?? undefined },
          },
        },
      );
      if (!cancelled && data) setDrafts(data.data.items);
    }
    fetchDrafts();
    return () => {
      cancelled = true;
    };
  }, [yard.id, contractId]);

  return drafts;
}

export type ReportDraftButtonsProps = {
  drafts: ReportDraft[];
  onPick: (draft: ReportDraft) => void;
};

export function ReportDraftButtons({
  drafts,
  onPick,
}: ReportDraftButtonsProps) {
  if (drafts.length === 0) return null;
  return (
    <div className="mt-2 text-xs text-zinc-500">
      <p>Brouillons à reprendre :</p>
      <div className="mt-1 flex flex-wrap gap-2">
        {drafts.map((draft) => (
          <button
            key={draft.id}
            type="button"
            onClick={() => onPick(draft)}
            className="rounded border border-blue-300 px-2 py-0.5 text-blue-700 hover:bg-blue-50 dark:border-blue-700 dark:text-blue-300 dark:hover:bg-blue-900/20"
          >
            {draft.numero ?? `Rapport ${draft.id}`}
          </button>
        ))}
      </div>
    </div>
  );
}
